import { StringTokenValue } from 'designSystem/types';
import styled from 'styled-components';
import * as S from './styles';

interface StylesColorTokenPreviewProps {
	value: StringTokenValue;
}

// Color swatch that uses CSS variable directly via inline style
// This ensures the browser can resolve the var() at runtime
const VarColorSwatch = styled.div`
	width: 100%;
	height: 60px;
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
`;

// Extract CSS variable name from var() reference
// e.g., "var(--theme-magenta-500)" -> "--theme-magenta-500"
function extractVariableName(varReference: string): string {
	const match = varReference.match(/var\((--[^,)]+)/);
	return match ? match[1] : varReference;
}

export const StylesColorTokenPreview = ({ value }: StylesColorTokenPreviewProps) => {
	// Extract "--theme-xxx" from "var(--theme-xxx)" and rebuild var() cleanly
	// This avoids double-wrapping issues
	const variableName = extractVariableName(value.original);

	return (
		<S.PreviewContainer>
			<VarColorSwatch style={{ backgroundColor: `var(${variableName})` }} />
		</S.PreviewContainer>
	);
};
